// extracted by mini-css-extract-plugin
export default {"sWraper":"dropdown_sWraper__2bL6b"};